export const TABS = {
  HOME: 'home',
  WORKOUT: 'workout', // Nuevo
  PLAN: 'plan',
  GAME: 'game',
  COMMUNITY: 'community',
  PROFILE: 'profile',
  SETTINGS: 'settings',
};

export const NAV_ITEMS = [
  { id: TABS.HOME, icon: '🏠', label: 'Inicio' },
  { id: TABS.WORKOUT, icon: '💪', label: 'Entrenar' }, // Prominente
  { id: TABS.PLAN, icon: '📅', label: 'Agenda' }, // Renombrado
  { id: TABS.GAME, icon: '🏅', label: 'Logros' },
  { id: TABS.PROFILE, icon: '👤', label: 'Perfil' },
];
